import { BaseService } from "./base.service";
import gateway from "@interceptors/gateway.interceptor"

class ContactService extends BaseService{
    public getContactInfo = async (id: number) => {
        const url = `contact/find-by-accomodation-id/${id}`;
        const response = await gateway.get(url);
        return response.data;
    }

    public updateContactInfo = async (id: number, data: any) => {
        const url = `contact/update/${id}`;
        const response = await gateway.put(url, data);
        return response.data;
    }
}

export default new ContactService();